/* global Plotly */
// Plot.js
import React from 'react';
import PropTypes from 'prop-types';

let plotself;

class Plot extends React.Component {

    constructor(props) {
        //console.log("Plot created");
        super(props);
//removing .x and using .time everywhere
        plotself = this;
        this.secondsPerCandle = 1800;
        this.state = {
            trace1: {
                close: [],
                high: [],
                low: [],
                open: [],
                time: []
            },
            numPoints: 0
        }

    }

    componentDidMount() {
        window.addEventListener("resize",()=>{
          this.setState({rando: Math.random()});
          console.log("resize");
        });
        //console.log("Plot componentDidMount");
        this.getXRange = function (trace) {
            //console.log(trace);
            if (!trace || trace.time.length === 0) {
                return [0, 1];
            } else {
                return [0, trace.time.length - 1];
            }
        };
        this.getYRange = function (trace) {
            if (!trace || trace.time.length === 0) {
                return [10, 30];
            } else {
                return [trace.low.reduce( (a, b) => parseFloat(a) <= parseFloat(b) ? a : b),
                        trace.high.reduce((a, b) => parseFloat(a) >= parseFloat(b) ? a : b)];
            }
        };
        this.getXSlide = function (trace) {
            if (!trace || trace.time.length === 0) {
                return {range: [0, 1]};
            } else {
                return {range: [Math.max(0, trace.time.length - 11), trace.time.length - 1]};
            }
        };

        this.handlePoints = function (points) {

            const needsNewCandle = function (point, currentCandle) {
                let nextTime = new Date(point.time);
                if (!currentCandle || new Date(currentCandle.time).toJSON().substr(0, 10) !== nextTime.toJSON().substr(0, 10)) {
                    let price = parseFloat(parseFloat(point.price).toFixed(2));
                    let now = new Date(point.time).getTime();
                    let newCurrentCandle = {
                        time: new Date(now).toJSON(),
                        open: price,
                        close: price,
                        high: price,
                        low: price,
                    };
                    return [newCurrentCandle];

                }
                let now = new Date(point.time).getTime();
                let then = new Date(currentCandle.time).getTime();
                //Decides if needs new candle
                const secondsPerCandle = plotself.secondsPerCandle;
                const cutOff = new Date(then);
                cutOff.setSeconds(cutOff.getSeconds() + secondsPerCandle);
                if (now < cutOff.getTime() || nextTime.getUTCHours() >= 16) { //listen for 4pm here!
                    return false;
                }
                else {
                    //Generate Empty Candles
                    let numCandles = parseInt(Math.floor((now - then) / (secondsPerCandle * 1000)), 10);
                    let candles = [];
                    if (numCandles > 1) {
                        let emptyCandle = {
                            time: null,
                            high: currentCandle.close,
                            low: currentCandle.close,
                            open: currentCandle.close,
                            close: currentCandle.close,
                        };
                        for (let i = 1; i < numCandles; i++) {
                            candles.push(JSON.parse(JSON.stringify(emptyCandle)));
                            candles[i - 1].time = new Date(then + i * (secondsPerCandle * 1000)).toJSON();
                        }
                    }
                    let price = parseFloat(parseFloat(point.price).toFixed(2));
                    let newCurrentCandle = {
                        time: new Date(then + numCandles * (secondsPerCandle * 1000)).toJSON(),
                        open: price,
                        close: price,
                        high: price,
                        low: price,
                    };
                    candles.push(newCurrentCandle);
                    return candles;
                }
            };

            const mergePoint = function (point, currentCandle) {
                const price = parseFloat(point.price);
                const prettyPrice = parseFloat(price.toFixed(2));
                currentCandle.close = prettyPrice;
                if (price < currentCandle.low) {
                    currentCandle.low = prettyPrice;
                }
                else if (price > currentCandle.high) {
                    currentCandle.high = prettyPrice;
                }
                return JSON.parse(JSON.stringify(currentCandle));
            };

            //TODO: is this used?  const currentLength = this.state.trace1.time.length;
            const currentTrace = this.state.trace1;
            let currentNumPoints = this.state.numPoints;

            const getCurrentCandle = function (trace) {
                const length = trace.time.length;
                if (length === 0) {
                    return null;
                }
                return {
                    time: trace.time[length - 1],
                    low: trace.low[length - 1],
                    high: trace.high[length - 1],
                    close: trace.close[length - 1],
                    open: trace.open[length - 1]
                };
            };
            const currentCandle = getCurrentCandle(currentTrace);

            //start point loop here set state after all processing
            for (let j = 0; j < points.length; j++) {
                const point = points[j];
                const isNew = needsNewCandle(point, getCurrentCandle(currentTrace));
                if (!!isNew) {
                    //append new candle
                    for (let k = 0; k < isNew.length; k++) {
                        currentTrace.time.push(isNew[k].time);
                        currentTrace.close.push(isNew[k].close);
                        currentTrace.open.push(isNew[k].open);
                        currentTrace.high.push(isNew[k].high);
                        currentTrace.low.push(isNew[k].low);
                    }
                    currentNumPoints += 1;
                } else {
                    currentNumPoints += 1;
                    const updateCandle = mergePoint(point, getCurrentCandle(currentTrace));
                    currentTrace.time.pop();
                    currentTrace.time.push(updateCandle.time);
                    currentTrace.close.pop();
                    currentTrace.close.push(updateCandle.close);
                    currentTrace.high.pop();
                    currentTrace.high.push(updateCandle.high);
                    currentTrace.low.pop();
                    currentTrace.low.push(updateCandle.low);
                    currentTrace.open.pop();
                    currentTrace.open.push(updateCandle.open);
                }
            }
            this.setState({trace1: currentTrace, numPoints: currentNumPoints});
        };
        const timeseries = this.props.timeseries;
        this.handlePoints(timeseries);
    }

    componentWillReceiveProps(nextProps) {
        console.log("Plot componentWillReceiveProps " + nextProps);
        const count = this.state.numPoints;
        const propLength = nextProps.timeseries.length;
        this.handlePoints(nextProps.timeseries.slice(count, propLength));
    }

    componentWillUpdate(nextProps, nextState) {
        console.log("Plot componentWillUpdate " + nextProps + " " + nextState);
        //TODO: fix error where get Range is null array
        //console.log(nextState); //neither is null
        //console.log(nextState.trace1);
        const newTrace = Object.assign(nextState.trace1, {
            x: Array(nextState.trace1.time.length).fill().map((_, i) => i),
            decreasing: {line: {color: 'red'}},
            increasing: {line: {color: 'green'}},
            line: {color: 'rgba(31,119,180,1'},
            type: 'candlestick',
            xaxis: 'x',
            yaxis: 'y'
            //hoverinfo: 'skip'
        });
        const data = [newTrace];
        let wdth = document.querySelector('.graph-div').clientWidth;
        let hght = document.querySelector('.graph-div').clientHeight;
        const layout = {
            autosize: false,
            height: hght-34-15,
            width: wdth-30,
            dragmode: 'pan',
            paper_bgcolor: '#2D3748',
            plot_bgcolor:  '#2D3748',
            font: { color: '#FFFFFF' },
            margin: {
                r: 1,
                t: 5,
                b: 80,
                l: 34
            },
            showlegend: false,
            xaxis: {
                autorange: true,
                zoom: true,
                showticklabels:true,
                showgrid: true,
                gridcolor: '#4A5568',
                linecolor: '#4A5568',
//              //fixedrange: true,
                domain: [0, 1],
                range: this.getXRange(nextState.trace1),//this is null
                autorange:true,
                rangeslider: Object.assign(this.getXSlide(nextState.trace1), {visible:false}),
                type: 'linear',
                tickmode: "array",
                tickfont: {size:14},
                tickvals: Array(nextState.trace1.time.length).fill().map((_, i) => i),
                ticktext: nextState.trace1.time.map((stamp, i) => {
                    const numCandlesPerDay = 23400 / plotself.secondsPerCandle;
                    const d = new Date(stamp);
                    if (i % numCandlesPerDay === 0) {
                        return `OPEN ${d.getUTCMonth() + 1}-${d.getUTCDate()}`;
                    } else {
                        let dnum = d.getUTCMinutes();
                        if (dnum < 10) {
                            dnum = '0' + dnum;
                            return '';
                        }
                        return `${d.getUTCHours()}:${dnum}`;
                    }
                })
            },
            yaxis: {
                autorange: true,
                domain: [0, 1],
                range: this.getYRange(nextState.trace1), //so is this   (this is null too)
                //autorange: true,
                ticks:"",
                showticklabels:true,
                showgrid: true,
                gridcolor: '#4A5568',
                linecolor: '#4A5568',
                type: 'linear'
            }
        };
        Plotly.newPlot('plot', data, layout, {displayModeBar: false});
    }

    render() {
        //console.log("Plot render");
        return (
            <div>
                <div style={{ width: "100%", height: "100%", minHeight: "400px" }} id="plot" />            
            </div>
        );
    };
}

Plot.propTypes = {
    timeseries: PropTypes.array     // TODO:  finish changing everything in Plot.js    -nxb, June 4, 2022   
    // Might have to do with references to "point"  or maybe "series"   or maybe "trace"
};

export default Plot;



// WEBPACK FOOTER //
// ./src/components/Charts/Plot.js